import React, {useState,useEffect, useMemo, useRef} from "react";
import "./GalleryPage.css";
import product_banner from '../../assets/images/desktopImage_4_banner.jpg'
import product_banner_mobile from '../../assets/images/mobileImage_4.jpg'
import CommonBanner from "../../common/CommonBanner/CommonBanner";
import { useListAllGalleryQuery } from "../../api/gallery.api.js";
import LoadingComponent from "../../common/Loading/Loading.component.jsx";
import { mediaPreloader } from '../../utils/preloader';
import { Pagination } from 'flowbite-react';
import SEO from "../../common/SEO/SEO";


const  GalleryPage=()=> {
  const [page, setPage] = useState(1);
  const [limit] = useState(20); 
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const itemRef = useRef(null);
  // Optimized Intersection Observer for lazy loading
  const {data, error, isLoading} = useListAllGalleryQuery({page, limit,}, {
    // Remove React Query options - RTK Query handles caching differently
    refetchOnMountOrArgChange: false,
    skip: false, // Ensure query runs
  })
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Memoize the banner data to prevent unnecessary re-computations
  const galleries = useMemo(() => {
    return data?.result?.allImages || [];
  }, [data]);



  // Advanced preloading with batch processing
  useEffect(() => {
    if (galleries && !assetsLoaded) {
      const preloadAssets = async () => {
        try {
          const assets = [];
          galleries.forEach(item => {
            assets.push(
              { type: 'image', src: item, priority: 'high' }
            );
          });
  
          // Batch preload all assets
          await mediaPreloader.batchPreload(assets);
          setAssetsLoaded(true);
        } catch (error) {
          console.warn('Asset preloading failed:', error);
          setAssetsLoaded(true); // Still show content even if preload fails
        }
      };
      preloadAssets();
    }
  }, [galleries, assetsLoaded]);

    if(isLoading){
        return <LoadingComponent
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            backgroundColor: '#f9f9f9',
          }}          
        />
    }

  return (
    <>
      <SEO
        title="Editorial Lookbook & Visual Gallery"
        description="Explore Maya Wears visual lookbook, campaign imagery, and contemporary Nepali streetwear styling."
        keywords="Maya Wears gallery, lookbook Nepal, streetwear fashion shoot, Nepali contemporary fashion, streetwear aesthetic"
      />
      <CommonBanner product_banner={product_banner} product_banner_mobile={product_banner_mobile} title="Gallery" />
      
      <div className="img_containor" ref={itemRef}>
        {galleries.map((item, index) => (
            <a href={item} target="_blank" rel="noopener noreferrer" key={index}>
              <img src={item} alt={`Maya Wears Editorial Look ${index + 1}`} loading="lazy"/>
            </a>
        ))}        
      </div>  

      <div className='flex overflow-x-auto sm:justify-center'>
            {data?.meta && data?.meta.total > 0 && (
            <div className='flex overflow-x-auto sm:justify-center'>
                <Pagination
                currentPage={data?.meta.currentPage}
                totalPages={Math.ceil(data?.meta.total / limit)}
                onPageChange={handlePageChange}
                />
            </div>
            )}
        </div>   

    </>
  );
}

export default GalleryPage;
